
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Pagination',
  props: {
    url: { type: String, required: true },
    queryParams: { type: Object, required: false, default: () => {} },
    type: { type: String, required: false, default: 'typless' },
  },
  data() {
    return {
      paginationKeys: [null],
      tableLoading: false,
      itemsPerPage: 10,
      itemsLength: 1,
      pageItems: [],
      currentPage: 0,
      timeout: null,
    };
  },
  watch: {
    queryParams(value) {
      this.debouncedFetchData({
        itemsPerPage: this.itemsPerPage,
        page: this.currentPage + 1,
      });
    },
  },
  methods: {
    debouncedFetchData(options) {
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.fetchData(options);
      }, 400);
    },
    async fetchData(options) {
      try {
        const page = options.page - 1;
        if (this.itemsPerPage !== options.itemsPerPage) {
          this.itemsPerPage = options.itemsPerPage;
          this.paginationKeys = [null];
          this.itemsLength = 1;
        }
        this.tableLoading = true;
        const lastKey = this.paginationKeys[page];
        const queryParams = {
          ...this.queryParams,
          limit: this.itemsPerPage,
          last_key: lastKey,
        };
        if (queryParams.name) {
          delete queryParams.last_key;
        }
        const qpString = new URLSearchParams(queryParams);
        const url = `${this.url}?${qpString.toString()}`;
        let data;
        if (this.type === 'accountless') {
          data = await this.$accountlessApi.$get(`${url}`);
        } else {
          data = await this.$axios.$get(`${url}`);
        }
        if (data.last_key && !this.paginationKeys[page + 1]) {
          this.paginationKeys.push(data.last_key);
          this.extendItemsLength(data.last_key);
        }
        this.currentPage = page;
        this.pageItems = data.results;
      } catch (err) {
        this.$snackbar.showMessage({
          content: err,
          color: 'error',
        });
      } finally {
        this.tableLoading = false;
      }
    },
    async refreshTable() {
      try {
        await this.fetchData({
          itemsPerPage: this.itemsPerPage,
          page: this.currentPage + 1,
        });
      } catch (err) {
        this.$snackbar.showMessage({
          content: err,
          color: 'error',
        });
      }
    },
    extendItemsLength(lastKey) {
      if (lastKey) {
        this.itemsLength += this.itemsPerPage;
      }
    },
    resetTableState() {
      this.currentPage = 0;
      this.paginationKeys = [null];
      this.itemsLength = 1;
    },
  },
  render() {
    return this.$scopedSlots.default({
      pageItems: this.pageItems,
      tableLoading: this.tableLoading,
      itemsLength: this.itemsLength,
      fetchData: this.fetchData,
      refreshTable: this.refreshTable,
      paginationKeys: this.paginationKeys,
      resetTableState: this.resetTableState,
      currentPage: this.currentPage,
    });
  },
};
